import React, {memo} from 'react';

import {SearchDateRangeDisplay} from '../SearchDateRangeDisplay/SearchDateRangeDisplay';

import {useComponent} from './hooks/useComponent';

import './SearchDatesPickerModalTitle.less';

const SearchDatesPickerModalTitle = memo(function SearchDatesPickerModalTitle() {
    const {
        className,
        locale,
        startLabel,
        endLabel,
        startDate,
        endDate,
        // dateFormatOptions
        isSelecting
    } = useComponent();

    return (
        <div className={className}>
            <SearchDateRangeDisplay
                locale={locale}
                startLabel={startLabel}
                endLabel={endLabel}
                startDate={startDate}
                endDate={endDate}
                // dateFormatOptions={dateFormatOptions}
                isSelecting={isSelecting}
            />
        </div>
    );
});

SearchDatesPickerModalTitle.whyDidYouRender = true;

export {SearchDatesPickerModalTitle};
